// web3.js
function connectMetaMaskWallet() {
  return new Promise((resolve, reject) => {
    if (typeof window.ethereum !== "undefined") {
      ethereum
        .request({ method: "eth_requestAccounts" })
        .then((accounts) => {
          const account = accounts[0];
          resolve(account);
        })
        .catch((error) => {
          console.log(error, error.code);
          reject(error);
        });
    } else {
      console.log("MetaMask not detected");
      reject(new Error("MetaMask not detected"));
    }
  });
}

export { connectMetaMaskWallet };
